import api from '@/api'

const { $academic, $commission } = api;

export const { $terms } = $academic;
export const { $range } = $commission;